import KCustomerForm from "kinnect-front/KCustomers/KCustomerForm";
import { Customer } from "kinnect-models";
import { KAvatarAutocomplete } from "kinnect-general";
import { VDialog, VIcon } from "vuetify/lib";

export default {
	name: "CustomerField",

	extends: KAvatarAutocomplete,

	props: {
		itemText: {
			default: "name",
			type: String
		},
		itemValue: {
			default: "id",
			type: String
		},
		noDataText: {
			default: "No customers to display",
			type: String
		},
		prependIcon: {
			default: "contact_phone",
			type: String
		},
		showAddButton: Boolean
	},

	data: () => ( {
		dialogOpen: false
	} ),

	methods: {
		createCustomer( { data: customer } ) {
			this.$emit( "create", new Customer( customer ) );
		}
	},

	render() {
		return <KAvatarAutocomplete
			attrs={{ ...this.$props }}
			on={{ ...this.$listeners }}
			scopedSlots={{ ...this.$scopedSlots }}
		>
			{this.showAddButton && <VDialog
				class="white"
				modal
				persistent
				scopedSlots={{ activator: ( { on } ) => <VIcon on={on}>add_circle</VIcon> }}
				slot="append-outer"
				vModel={this.dialogOpen}
				width="500"
			>
				{this.dialogOpen && <KCustomerForm
					formTitle="Add a Customer"
					onClose={() => this.dialogOpen = false}
					onSuccess={this.createCustomer}
				></KCustomerForm>}
			</VDialog>}
		</KAvatarAutocomplete>;
	}
};
